import React, {Component} from 'react';
import {Form, message, Modal, Select} from 'antd';
import {queryAccountList} from '@api/core/user';

const FormItem = Form.Item;

class Manage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accountList: [],
    };
  }

  componentDidMount() {
    queryAccountList().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          accountList: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  }

  handleOk = () => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.handleOk(values);
      }
    });
  };

  render() {
    const {
      form: { getFieldDecorator },
      visible,
      handleCancel,
    } = this.props;
    return (
      <Modal
        title="采购转交"
        visible={visible}
        onOk={this.handleOk}
        onCancel={() => handleCancel(false)}
      >
        <Form>
          <FormItem label="操作人">
            {getFieldDecorator('processor', {
              rules: [{ required: true, message: '请选择操作人' }],
            })(
              <Select
                showSearch
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {this.state.accountList.map(item => {
                  return (
                    <Select.Option value={item.uuid} key={item.uuid}>
                      {item.name}
                    </Select.Option>
                  );
                })}
              </Select>,
            )}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Manage);



// WEBPACK FOOTER //
// ./src/components/administrative/purchase/workflow/ModalPurchase.js